import React from 'react'

import { Icon__NewWindow as IconNewWindow } from 'components/patterns/Icon/components'
import { ReactComponent as IconBothEdges } from './assets/icons-help-panel-both-edges.svg'
import { ReactComponent as IconRisingEdge } from './assets/icons-help-panel-rising-edge.svg'
import { ReactComponent as IconFallingEdge } from './assets/icons-help-panel-falling-edge.svg'
import { ReactComponent as IconNoEdge } from './assets/icons-help-panel-no-edge.svg'

import { ReactComponent as FigureBothEdges } from './assets/both-edges.svg'
import { ReactComponent as FigureRisingEdge } from './assets/rising-edge.svg'
import { ReactComponent as FigureFallingEdge } from './assets/falling-edge.svg'
import { ReactComponent as FigureNoEdge } from './assets/no-edge.svg'

export default function () {
  return (
    <article>
      <div>
        <header>
          <h1>What does an Edge Trigger do?</h1>
        </header>
        <p>
          CHEC allows you to specify an edge trigger type for some inputs and
          signal types. Edge triggers let you specify exactly where in the
          signal waveform the XMC responds. This can be useful in situations
          where you may be monitoring a pulse or momentary switch.
        </p>
      </div>
      <section key="no-edge">
        <IconNoEdge />
        <div>
          <h2>
            No Edge <em>(default)</em>
          </h2>
          <p>
            Use the “No Edge” (level) trigger when you want the result (true or
            false) of the input condition to be passed to the logic gate.
          </p>
          <figure>
            <FigureNoEdge />
          </figure>
        </div>
      </section>
      <section key="both-edges">
        <IconBothEdges />
        <div>
          <h2>Both Edges</h2>
          <p>
            Use the “Both Edges” trigger when you want any change to the result
            of the input condition to be passed to the logic gate.
          </p>
          <figure>
            <FigureBothEdges />
          </figure>
        </div>
      </section>
      <section key="falling-edge">
        <IconFallingEdge />
        <div>
          <h2>Falling Edge</h2>
          <p>
            Use the “Falling Edge” trigger when you want the transition of the
            input condition from true to false to be passed to the logic gate.
          </p>
          <figure>
            <FigureFallingEdge />
          </figure>
        </div>
      </section>
      <section key="rising-edge">
        <IconRisingEdge />
        <div>
          <h2>Rising Edge</h2>
          <p>
            Use the “Rising Edge” trigger when you want the transition of the
            input condition from false to true to be passed to the logic gate.
          </p>
          <figure>
            <FigureRisingEdge />
          </figure>
        </div>
      </section>
      <p>
        Source:{' '}
        <a
          href="https://dtnacontent-dtna.prd.freightliner.com/content/dam/dtna-portal/en/service/chec_documentation/user-guides/CHEC%20CEEA+%20Tier%202%20User%20Guide.pdf"
          target="_blank"
          rel="noreferrer noopener"
        >
          CEEA+ Developer User Guide{' '}
          <IconNewWindow width={16} height={16} style={{ marginLeft: 8 }} />
        </a>
      </p>
    </article>
  )
}
